import { c as _c } from "react/compiler-runtime";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CircleLoader, { CircleLoaderSize } from "@/components/distribution-plan-tool/common/CircleLoader";
import GroupItem from "@/components/groups/select/item/GroupItem";
export default function SelectGroupModalItems(t0) {
  const $ = _c(8);
  const {
    groups,
    loading,
    onGroupSelect
  } = t0;
  if (loading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center"><CircleLoader size={CircleLoaderSize.XXLARGE} /></div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== groups || $[2] !== onGroupSelect) {
    let t2;
    if ($[4] !== onGroupSelect) {
      t2 = group => <GroupItem key={group.id} group={group} activeGroupId={null} onActiveGroupId={() => onGroupSelect(group)} />;
      $[4] = onGroupSelect;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    t1 = groups.map(t2);
    $[1] = groups;
    $[2] = onGroupSelect;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[6] !== t1) {
    t2 = <ul className="tw-list-none tw-pl-0 tw-gap-y-4 tw-flex tw-flex-col">{t1}</ul>;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}